import axios from 'axios';
import { buildHeaders } from './_headers.util';

const API_URL = `${process.env.VUE_APP_API_URL}payroll-additions/`;

export default {
  async getAll() {
    const res = await axios.get(API_URL, { headers: buildHeaders() });
    return res.data;
  },
  async create(data) {
    return axios.post(API_URL, data, { headers: buildHeaders() });
  },
  async update(id, data) {
    return axios.put(`${API_URL}${id}`, data, { headers: buildHeaders() });
  },
  async delete(id) {
    return axios.delete(`${API_URL}${id}`, { headers: buildHeaders() });
  },
};
